import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import {DatePipe} from '@angular/common';
import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {TableSorterHeaderDirective} from '../../../../../directives/table-sorter/table-sorter-header.directive';
import {RouterLink} from '@angular/router';
import {TableSorterDirective} from '../../../../../directives/table-sorter/table-sorter.directive';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {BotPrompt} from '../../../../../models/bot-prompt';
import {BotPromptService} from '../../../../../services/bot-prompt/bot-prompt.service';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {CollapserTextComponent} from '../../../../layout/collapser-text/collapser-text.component';

@Component({
  selector: 'app-bot-prompt-list',
  imports: [
    ConfirmDirective,
    IsGrantedDirective,
    PaginatorComponent,
    TableSorterHeaderDirective,
    RouterLink,
    TableSorterDirective,
    DatePipe,
    CollapserTextComponent
  ],
  templateUrl: './bot-prompt-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bot-prompt-list.component.scss'
})
@MetaTitle('Bot Prompt List')
export class BotPromptListComponent implements OnInit {
  botPrompts: BotPrompt[] = [];

  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  constructor(
    private loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private botPromptService: BotPromptService,
  ) {
  }

  ngOnInit(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.botPromptService.findAll({}, this.paginator, this.tableSorter).subscribe(botPrompts => {
      this.botPrompts = botPrompts;
      this.loader.stopLoading();
    });
  }

  delete(botPrompt: BotPrompt): void {
    if (botPrompt.id) {
      this.loader.startLoading();
      this.botPromptService.delete(botPrompt.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('Advertiser has been deleted');
        this.fetchAll();
      });
    }
  }
}
